import * as _ from 'lodash';
import { Utils } from '../../Utils/Utils';
import { TimespanValidator } from './Validators/TimespanValidator';
import { EmailValidator } from './Validators/EmailValidator';
import { UrlValidator } from './Validators/UrlValidator';
import { RangeValidator } from './Validators/RangeValidator';
import { MaxLengthValidator } from './Validators/MaxLengthValidator';
import { ValidatorBase } from './Validators/ValidatorBase';
import { StringUtils } from '../../Utils/StringUtils';

export class ValidatorManager {
    private validators: ValidatorBase[];

    public constructor(htmlItem: HTMLElement) {
        this.validators = new Array();

        if (!Utils.isNullOrUndefined(htmlItem.dataset["validatorTimespan"])) {
            this.validators.push(new TimespanValidator(htmlItem.dataset["validatorTimespanMessage"], htmlItem.dataset["validatorTimespan"]));
        }
        if (!Utils.isNullOrUndefined(htmlItem.dataset["validatorEmail"])) {
            this.validators.push(new EmailValidator(htmlItem.dataset["validatorEmailMessage"], htmlItem.dataset["validatorEmail"]));
        }
        if (!Utils.isNullOrUndefined(htmlItem.dataset["validatorUrl"])) {
            this.validators.push(new UrlValidator(htmlItem.dataset["validatorUrlMessage"], htmlItem.dataset["validatorUrl"]));
        }
        if (!Utils.isNullOrUndefined(htmlItem.dataset["validatorRange"])) {
            this.validators.push(new RangeValidator(htmlItem.dataset["validatorRangeMessage"], htmlItem.dataset["validatorRange"]));
        }
        if (!Utils.isNullOrUndefined(htmlItem.dataset["validatorMaxlength"])) {
            this.validators.push(new MaxLengthValidator(htmlItem.dataset["validatorMaxlengthMessage"], htmlItem.dataset["validatorMaxlength"]));
        }
    }

    public validate(value: string, messages: string[]) {
        if (StringUtils.isNullOrEmpty(value)) {
            return;
        }
        for (let i = 0; i < this.validators.length; i++) {
            let validator = this.validators[i];
            validator.validate(value, messages);
        }
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Components/ConfigurationPanel/ValidatorManager.ts
 **/